var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-main"},[_c('h3',[_vm._v(_vm._s(_vm.$t('participation.addTeam')))]),_c('participant',{attrs:{"participantType":"team"},on:{"submit":function($event){return _vm.update($event)},"cancel":function($event){return _vm.cancel()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }